<template>
  <svg class="radar_dot" :height="size" :width="size">
    <circle
      class="radar_dot__inner"
      :cx="circleOuterRadius + 1"
      :cy="circleOuterRadius + 1"
      :r="circleInnerRadius"
      :stroke="circleColor"
      stroke-width="0"
      :fill="circleColor"
    />
    <circle
      class="radar_dot__outer"
      :cx="circleOuterRadius + 1"
      :cy="circleOuterRadius + 1"
      :r="circleOuterRadius"
      :stroke="circleColor"
      :stroke-width="isActive ? 1 : 0"
      fill="transparent"
    />

    <circle
      v-if="!isActive"
      class="radar_dot__pulsing"
      :cx="circleOuterRadius + 1"
      :cy="circleOuterRadius + 1"
      :r="circleOuterRadius"
      :stroke="circleColor"
      fill="transparent"
      stroke-width="2"
    >
      <animate attributeName="r" from="3" to="10" dur="1.5s" begin="0s" repeatCount="indefinite" />
      <animate
        attributeName="opacity"
        from="1"
        to="0"
        dur="1.5s"
        begin="0s"
        repeatCount="indefinite"
      />
    </circle>
  </svg>
</template>

<script>
const CIRCLE_INNER_RADIUS = 5;
const CIRCLE_OUTER_RADIUS = 12;

export default {
  name: 'RadarDot',

  props: {
    circleColor: {
      type: String,
      required: true,
    },
    isActive: {
      type: Boolean,
      required: true,
    },
  },

  data() {
    return {
      circleInnerRadius: CIRCLE_INNER_RADIUS,
      circleOuterRadius: CIRCLE_OUTER_RADIUS,
    };
  },

  computed: {
    size() {
      return this.circleOuterRadius * 2 + 2;
    },
  },
};
</script>

<style lang="scss" scoped>
/*.radar_dot__inner {
  animation: pulsate 2s 2 ease-in-out;
  stroke: $color-white;
}*/
</style>
